import { z } from 'zod';
import { ButtonsBlockSchema } from './buttons';
import { ConsentBlockSchema } from './consent';
import { FormBlockSchema } from './form';
import { LiveTileBlockSchema } from './liveTile';
import { MediaBlockSchema } from './media';
import { RatingBlockSchema } from './rating';
import { TextBlockSchema } from './text';
import { WebEmbedBlockSchema } from './webEmbed';
import {
  CalendarWidgetBlockSchema,
  ClockWidgetBlockSchema,
  DeparturesWidgetBlockSchema,
  EnergyWidgetBlockSchema,
  NewsWidgetBlockSchema,
  NoticeWidgetBlockSchema,
  QrWidgetBlockSchema,
  SlideshowWidgetBlockSchema,
  SolarWidgetBlockSchema,
  SportWidgetBlockSchema,
  WeatherWidgetBlockSchema
} from './widgets';

export { ButtonsBlockSchema, ConsentBlockSchema, FormBlockSchema, LiveTileBlockSchema, MediaBlockSchema, RatingBlockSchema, TextBlockSchema, WebEmbedBlockSchema };
export { QuizBlockSchema } from './quiz';
export type { QuizBlock } from './quiz';
export {
  ClockWidgetBlockSchema,
  WeatherWidgetBlockSchema,
  NewsWidgetBlockSchema,
  SportWidgetBlockSchema,
  SolarWidgetBlockSchema,
  CalendarWidgetBlockSchema,
  SlideshowWidgetBlockSchema,
  DeparturesWidgetBlockSchema,
  EnergyWidgetBlockSchema,
  NoticeWidgetBlockSchema,
  QrWidgetBlockSchema,
  WIDGET_BLOCK_SCHEMAS,
  WIDGET_BLOCK_TYPES,
  CLOCK_STYLES,
  DataSourceRefSchema
} from './widgets';
export type {
  ClockWidgetBlock,
  WeatherWidgetBlock,
  NewsWidgetBlock,
  SportWidgetBlock,
  SolarWidgetBlock,
  CalendarWidgetBlock,
  SlideshowWidgetBlock,
  DeparturesWidgetBlock,
  EnergyWidgetBlock,
  NoticeWidgetBlock,
  QrWidgetBlock,
  WidgetBlockType,
  DataSourceRef
} from './widgets';

export const BlockSchema = z.discriminatedUnion('type', [
  MediaBlockSchema,
  TextBlockSchema,
  ButtonsBlockSchema,
  FormBlockSchema,
  ConsentBlockSchema,
  RatingBlockSchema,
  LiveTileBlockSchema,
  WebEmbedBlockSchema,
  // §3 widgets (X0.1). Each is `tablet_only` until its server SVG renderer
  // exists; the capability table carries the badge.
  ClockWidgetBlockSchema,
  WeatherWidgetBlockSchema,
  NewsWidgetBlockSchema,
  SportWidgetBlockSchema,
  SolarWidgetBlockSchema,
  CalendarWidgetBlockSchema,
  SlideshowWidgetBlockSchema,
  DeparturesWidgetBlockSchema,
  EnergyWidgetBlockSchema,
  NoticeWidgetBlockSchema,
  QrWidgetBlockSchema
]);
export type Block = z.infer<typeof BlockSchema>;
